import { t } from 'ttag';

export const DAY = 86400000;
export const WEEK = DAY * 7;
export const MONTH = DAY * 31;
export const YEAR = DAY * 365;

export const PERIOD_HOURLY = 'hour';
export const PERIOD_DAILY = 'day';
export const PERIOD_MONTHLY = 'month';
export const PERIOD_YEARLY = 'year';

export const TYPE_TIMELINE = 'timeline';
export const TYPE_DEVICES = 'devices';
export const TYPE_COUNT = 'count';
export const TYPE_PEOPLE = 'people';
export const TYPE_CHECKIN = 'checkin';
export const TYPE_CHECKOUT = 'checkout';

export const PERIOD_LABEL = () => ({
  [PERIOD_HOURLY]: t`Hour`,
  [PERIOD_DAILY]: t`Day`,
  [PERIOD_MONTHLY]: t`Month`,
  [PERIOD_YEARLY]: t`Year`,
});

export const ENTITY_TYPE_SECTIONS = 'sections';
export const ENTITY_TYPE_SESSIONS = 'sessions';
export const ENTITY_TYPE_EVENTS = 'events';
export const ENTITY_TYPE_COMPANIES = 'companies';
export const ENTITY_TYPE_DOCUMENTS = 'documents';
export const ENTITY_TYPE_VIDEO = 'video';
export const ENTITY_TYPE_EXTERNAL_LINKS = 'external_links';

export const EXPORT_COLLECTION_PAGE_VIEW = 'pageviews';
export const EXPORT_COLLECTION_CLICKS = 'clicks';
export const EXPORT_COLLECTION_VIDEO = 'video';
export const EXPORT_COLLECTION_CHECKIN = 'checkins';
// `mobi_ai` is used as both the `collection` and the `product` discriminator
// in export payloads — one constant covers both BE keys.
export const EXPORT_COLLECTION_MOBI_AI = 'mobi_ai';
export const EXPORT_OPERATION_PEOPLE = 'people';
export const EXPORT_OPERATION_COUNT = 'count';

export const TAB_OVERVIEW = 'overview';
export const TAB_PEOPLE = 'people';
export const TAB_GAMIFICATION = 'gamification';
export const TAB_SPONSORSHIP = 'sponsorship';
export const TAB_LIVESTREAM = 'livestream';
export const TAB_VIDEO = 'video';
export const TAB_NETWORKING = 'networking';
export const TAB_SESSION = 'session';

export const DEVICE_MOBILE_PHONE = 'mobile phone';
export const DEVICE_MOBILE = 'mobile device';
export const DEVICE_DESKTOP = 'desktop';
export const DEVICE_TABLET = 'tablet';
export const DEVICE_OTHER = 'other';
